/** Words the plan panel prints on its two bases: the headline against the standing policy, the Change column against the no-change plan. */
/** The headline's basis, said where it is read (it used to sit only in a hover hint). */
export const HEADLINE_CAPTION = "a share over three years, against your standing policy";
/** The Change column's basis: the plan the cause sentences compare with. */
export const CHANGE_HEADER = ["Vs ", "no-change plan"] as const;
